"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsxs, jsx } from 'react/jsx-runtime';
import { schemaWithTitle } from '@membranehq/sdk';
import { EditorTagBadge, EditorTagBadgeIcon } from '../../ComboBox/Badges/EditorTagBadge/index.mjs';
import { SvgIconType } from '../../SvgIcon/svg-icon-type.mjs';
import { forwardRef } from 'react';
import { makeDataField } from '../index.mjs';
import useDataBuilderField from '../use-data-builder-field.mjs';
import { useFormComponents } from '../use-form-components.mjs';

const MergeObjectsFormula = forwardRef(
  (props, ref) => {
    return /* @__PURE__ */ jsxs(EditorTagBadge, { variant: "formula", ref, onClick: props.onClick, onDelete: props.onDelete, children: [
      /* @__PURE__ */ jsx(EditorTagBadgeIcon, { type: SvgIconType.Function }),
      " Merge objects"
    ] });
  }
);
MergeObjectsFormula.displayName = "MergeObjectsFormula";
function MergeObjectsDropdown({
  onChange,
  formula
}) {
  const { field } = useDataBuilderField();
  const { DataBuilderForm } = useFormComponents();
  const dataField = makeDataField({
    schema: schemaWithTitle(
      {
        type: "array",
        items: field.schema
      },
      "Objects to Merge"
    ),
    value: formula.args,
    variablesSchema: field.variablesSchema
  });
  return /* @__PURE__ */ jsx(
    DataBuilderForm,
    {
      field: dataField,
      onChange: (value) => {
        onChange?.({ $mergeObjects: value });
      }
    }
  );
}

export { MergeObjectsDropdown, MergeObjectsFormula as default };
